import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const MyUserService = {
    get: async () => axios.get(`${API_KEEPER}/my-user/get`).then(({data}) => data).catch((err) => { throw err }),

    getImage: async (imageId) => axios.get(`${API_KEEPER}/general/image/${imageId}`, {responseType: 'blob'}).then(({data}) => data).catch((err) => { throw err }),

    setImage: async (formData) => axios.post(`${API_KEEPER}/my-user/image/set`, formData).catch((err) => { throw err }),

    receiveSentryNews: async (formData) => axios.post(`${API_KEEPER}/my-user/update/receive-sentry-news`, formData).catch((err) => { throw err }),

    updateName: async (formData) => axios.post(`${API_KEEPER}/my-user/update/name`, formData).catch((err) => { throw err }),

    updateNameWar: async (formData) => axios.post(`${API_KEEPER}/my-user/update/name-war`, formData).catch((err) => { throw err }),

    validateEmail: async (formData) => axios.post(`${API_KEEPER}/user/validate-email/start`, formData).catch((err) => { throw err }),

    updateEmail: async (formData) => axios.post(`${API_KEEPER}/user/validate-email/validate-and-persist`, formData).catch((err) => { throw err }),

    shareContactInfo: async (formData) => axios.post(`${API_KEEPER}/my-user/update/share-contact-info`, formData).catch((err) => { throw err }),

    setSignature: async (formData) => axios.post(`${API_KEEPER}/my-user/signature/set`, formData).catch((err) => { throw err }),

    removeSignature: async () => axios.post(`${API_KEEPER}/my-user/signature/remove`).catch((err) => { throw err }),

    updatePassword: async (formData) => axios.post(`${API_KEEPER}/my-user/update/password`, formData).catch((err) => { throw err }),

    removeTrustedDevice: async (formData) => axios.post(`${API_KEEPER}/my-user/trusted-devices/remove`, formData).catch((err) => { throw err }),

    twoFactorEnabled: async (formData) => axios.post(`${API_KEEPER}/my-user/update/two-factor-enabled`, formData).catch((err) => { throw err }),

    totpRemove: async () => axios.post(`${API_KEEPER}/my-user/two-factor/config/totp/remove`).catch((err) => { throw err }),

    totpStart: async () => axios.get(`${API_KEEPER}/my-user/two-factor/config/totp/start`).then(({data}) => data).catch((err) => { throw err }),

    totpValidate: async (formData) => axios.post(`${API_KEEPER}/my-user/two-factor/config/totp/validate`, formData).catch((err) => { throw err }),

    declareUpToDate: async () => axios.get(`${API_KEEPER}/my-user/declare-up-to-date`).catch((err) => { throw err }),

    ignoreStaleData: async () => axios.get(`${API_KEEPER}/my-user/ignore-stale-data`).catch((err) => { throw err }),

    updatePin: async (formData) => axios.post(`${API_KEEPER}/my-user/update/pin`, formData).catch((err) => { throw err }),
};

export default MyUserService;